































































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { PipelineCategories, PipelineCategory } from '@/api/types'
import { Branch } from '@/api/model/branch'
import EditPipelineTeamsModal from '@/components/modal/EditPipelineTeamsModal.vue'
import ModuleEnabled from '@/components/ModuleEnabled.vue'
import { InputSelectOption } from '@/helpers/options'
import InputMultiSelect from '@/components/input/InputMultiSelect.vue'
import TooltipDecorator from '@/components/input/label/decorator/TooltipDecorator.vue'

@Component({
    components: {
        TooltipDecorator,
        InputMultiSelect,
        ModuleEnabled,
        EditPipelineTeamsModal,
    },
})
export default class EditPipelineForm extends Vue {
    @Prop() readonly pipeline!: Pipeline
    @Prop({ default: false }) readonly inUse!: boolean
    @Prop({ default: true }) readonly canBeActivated!: boolean
    @Prop({ default: () => [] }) readonly afspraakTypes!: string[]
    value: Pipeline = null
    showTeamsModal: boolean = false

    mounted() {
        this.setValue()
    }

    setValue() {
        if (!this.pipeline) {
            return
        }

        this.value = this.pipeline.clone()
    }

    @Watch('canBeActivated')
    onCanBeActivatedChange(): void {
        if (this.value.active === false || this.canBeActivated) {
            return
        }

        // If the pipeline was active and can't be activated anymore, we set it to inactive.
        this.value.active = false
        this.savePipeline()
    }

    async cancelEditing(): Promise<void> {
        this.$emit('cancel-form')
    }

    async savePipeline(): Promise<void> {
        this.$emit('save-pipeline', this.value)
    }

    async removePipeline(): Promise<void> {
        this.$emit('remove-pipeline', this.value)
    }

    get options(): Array<{label: string|null, value: string|number}> {
        return PipelineCategories.map((pipelineCategory: PipelineCategory) => {
            return {
                label: this.$t('pipeline.category.' + pipelineCategory).toString(),
                value: pipelineCategory,
            }
        })
    }

    get isValid(): boolean {
        const array = [undefined, null, '']
        return !array.includes(this.value.name)
            && PipelineCategories.includes(this.value.category)
    }

    get availableBranches(): Branch[] {
        return this.$currentCompany.getAvailableBranches()
    }

    get availableAgendaTypes(): InputSelectOption[] {
        return this.afspraakTypes.map((agendaType: string) => ({
            label: agendaType,
            value: agendaType,
        }))
    }

    onUpdatePipelineTeams(pipeline) {
        // Sync pipeline teams properties to prevent save of pipeline (this.value) overwriting changes made in the pipeline teams modal
        this.value.linkedBranches = pipeline.linkedBranches
        this.value.branches = pipeline.branches
        this.value.fallbackBranch = pipeline.fallbackBranch
    }
}
